export const STORAGE_KEY = "cineblocks:selected-project-id"
